import getCroppedImg from '@general/helpers/cropImage.helpers';

const useImageCropper = () => {
    const getCropped = async ({ file, croppedAreaPixels, finalHeight, finalWidth }) => {
        try {
            const cropped = await getCroppedImg({
                imageSrc: file,
                pixelCrop: croppedAreaPixels,
                finalHeight,
                finalWidth,
            });
            return cropped;
        } catch (e) {
            // console.error(e);
        }
    };
    return { getCropped };
};

export default useImageCropper;
